import { principles, voices } from "@/mocks/site";

export default function VoicesPanel() {
  return (
    <section>
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">我们坚持的几件事</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            蝌蚪爆料不生产结论，只负责把公开信息和时间顺序整理好，剩下的判断留给你。
          </p>
          <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {principles.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
          <h2 className="font-heading text-xl font-bold text-foreground-950">读者怎么说</h2>
          <ul className="mt-6 space-y-5">
            {voices.map((voice) => (
              <li key={voice.name} className="border-l-2 border-primary-300 pl-4">
                <p className="text-sm leading-relaxed text-foreground-700">“{voice.text}”</p>
                <div className="mt-2 flex items-center gap-2">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-100 font-heading text-xs font-bold text-primary-700">
                    {voice.name.slice(0, 1)}
                  </span>
                  <span className="text-xs font-medium text-foreground-900">{voice.name}</span>
                  <span className="text-xs text-foreground-500">· {voice.role}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}